/**
 * The API returns the season start as YYYY-MM-DD. Format it as a local date
 * (new Date('2026-09-29') is UTC midnight, the day before in the Americas).
 */
export function formatSeasonStart(isoDate) {
  const [year, month, day] = String(isoDate).split('-').map(Number);
  if (!year || !month || !day) return '';
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}
